<template>
  <div id="myDateShow">
    <div class="title">{{video.id?"修改":"新增"}} 微视频</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">微视频名称</div>
        <div class="value">
          <el-input class="w500" v-model="video.title" placeholder="请填写微视频名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">微视频类型</div>
        <div class="value">
          <el-select class="w500" v-model="video.videoClassifyId" placeholder="请选择微视频类型">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <div class="key">微视频描述</div>
        <div class="value">
          <el-input class="w500" v-model="video.videoDetail" placeholder="请填写微视频描述"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">视频制作人/农基商</div>
        <div class="value">
          <el-input class="w500" v-model="video.merchantsName" placeholder="视频制作人/农基商"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">是否需要被推荐</div>
        <div class="value">
          <el-input class="w500" v-model="video.isRecommend" placeholder="请填写0或1，0：推荐，1：不推荐"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">是否上线</div>
        <div class="value">
          <el-input class="w500" v-model="video.isOnline" placeholder="请填写0或1，0：上线，1：不上线"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">视频封面图</div>
        <div class="value">
          <img class="skuImg" v-show="video.defaultImg" :src="video.defaultImg" alt="">
          <div class="upload">
            <el-upload
                    ref="defaultUpload"
                    :on-change="defaultUpload"
                    :on-success="defaultSuccess"
                    class="upload-demo"
                    name="multipartFile"
                    action="http://8.129.52.149:8080/xsalo/video/uploadDefaultImg"
                    :auto-upload="false"
                    :show-file-list="false"
                    list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div class="el-upload__tip" slot="tip">上传视频封面图，图片长宽为4：3，文件格式为通用jpg/png，且不超过500kb，数量：1</div>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <i v-show="video.isImg"></i>
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getVideoById, newVue, updateVideo} from "../../network/video";

  export default {
    name: "VideoInsert",
    data(){
      return{
        video: {
          isImg: false
        },
        videoId: '',
        options: [
          {
            value:1,
            label:"新品推特"
          },
          {
            value:2,
            label:"优品促销"
          },
          {
            value:3,
            label:"会员拉新"
          },
        ],
        headers:{
          "Access-Control-Allow-Origin": "*"
        }
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/video/list";
      this.common.HeaderLocationTwo.name =  "微视频管理"
      this.common.HeaderLocationThree.name = "新增or修改微视频"
      if (this.$route.params.id!=null){
        this.videoId = this.$route.params.id;

        getVideoById(this.videoId).then(res => {
          this.video = res.data;
        })
      }


    },
    methods: {
      defaultSuccess(response){
        this.video.defaultImg =response.data
        this.video.isImg = !this.video.isImg
      },
      backClick(){
        this.$router.push("../list");
      },
      submit(){
        updateVideo(this.video).then(res => {
          console.log(res);
        })
      },
      defaultUpload(file) {
        console.log(file);
        if (file.name.indexOf("png") || file.name.indexOf("jp")) {
          if(file.size / 1024  < 500){
            this.$refs.defaultUpload.submit()
          }
        } else {
          this.$message({
            showClose: true,
            message: '请上传jpg或png等图片',
            type: 'error'
          })
        }
      },
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
  .skuImg{
    width: 200px;
    height: 150px;
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
  }
  .upload{
    display: inline-block;
  }
</style>
